function Header() {
  return (
    <div
      className="main-contact-header w-full h-1/3 flex flex-col justify-end items-center text-custom_black"
      dir="rtl"
    >
      <h1>تماس با من</h1>
      <p className="text-custom_pink font-extralight">
        برای تماس با من از فرم زیر استفاده کنید
      </p>
    </div>
  );
}

export default Header;
